import {ContentRoute} from "../../../models/Route";
import PerfilList from "./perfilList";
import PerfilForm from "./perfilForm";

// Cadastro de perfis de privilegio (#484909). So o master abre: o programa
// "perfis" e somente_master no config/acesso.yaml do backend.
export const perfil_content_routes: Array<ContentRoute> = [
    {
        'path':'/perfil',
        'description': 'Perfis de Privilégio',
        'exact':true,
        'component': PerfilList,
        'menu': true
    },
    {
        'path':'/perfil/incluir',
        'description': 'Incluir Perfil',
        'exact':true,
        'component': PerfilForm,
        'menu': false
    },
    {
        'path':'/perfil/alterar/:id',
        'description': 'Alterar Perfil',
        'exact':true,
        'component': PerfilForm,
        'menu': false
    },
    {
        'path':'/perfil/visualizar/:id',
        'description': 'Visualizar Perfil',
        'exact':true,
        'component': PerfilForm,
        'menu': false
    },
]
